export class FiltrosRepCobranzas{
   
    Usuario : string ='';
    Estado: string = '';
    Tipo: string = 'facturas_vencidas';
    idEmpresa_Factor: string = '7';
 
 }